module.exports = __webpack_public_path__ + "img/waterwater.cc15b15b.png";